import { useEffect, useState } from "react";
import "../../pages/navbar.css";
import {
  Box,
  Breadcrumbs,
  Button,
  Card,
  Chip,
  Container,
  Grid,
  Link,
  Stack,
  Typography,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { userAccountData, userProfileData } from "../../Common/profileInfo";
import { clientConfig } from "../../awsClientConfig";
import { GetPaymentMethodsByAccount } from "../../queries/GetPaymentMethodsByAccount";
import { UpdatePaymentMethod } from "../../queries/UpdatePaymentMethod";
import Loading from "../../Common/Loading";
import { fetchQuery } from "../../functions/misc";
import { GetProtectionPlanSubscription } from "../../queries/GetProtectionPlanSubscription";
import { paths } from "../../paths";
import { GetProtectionPlans } from "../../queries/GetProtectionPlans";
import { PlansTable } from "../plans/plans-table";
import { ReactComponent as CreditcardIcon} from '../../assets/CreditCard.svg';
import { Plan } from "../plans/plan";
import useProfileStore, { EnrollmentSource } from "../../store/ProfileStore";
import Footer from "../footer";

const PLANS = {
  BASIC: "Standard",
  STANDARD: "Premium",
  PRO: "Professional",
};

function ChangeProtectionPlan() {
  const navigate = useNavigate();
  const client = new clientConfig();
  const [loading, setLoading] = useState(false);
  const [currentSelectedPlan, setCurrentSelectedPlan] = useState<any>();

  const [plans, setPlans] = useState<any[]>([]);
  const [subscriptionInfo, setSubscriptionInfo] = useState<any>();
  const { primaryProfile }  = useProfileStore();
  

  useEffect(() => {
      fetchPlans();
  }, []);

  const fetchPlans = async () => {
    setLoading(true);
    client
    .query({
        query: GetProtectionPlans,
    })
    .then(async (res: any) => {
        if(res.data.GetProtectionPlans){
          if(primaryProfile && primaryProfile.EnrollmentSource === EnrollmentSource.Referral){
            setPlans(res.data.GetProtectionPlans.filter((planInfo:any) => (planInfo.Name === 'ProtectionPartnerMonitoring' || planInfo.Name === 'Free')));
          }else {
            setPlans(res.data.GetProtectionPlans.filter((planInfo:any) => (planInfo.Name !== 'ProtectionPartnerMonitoring')));
          }
          
        }
        const profileId = await userProfileData();
        const getSubscription = await fetchQuery({ ProfileId: profileId }, GetProtectionPlanSubscription);
        setSubscriptionInfo(getSubscription);
        setLoading(false);
    })
    .catch((error: any) => {
        console.log(error, "error");
        setLoading(false);
    });
  };

  const onPlanSelectHandler = (plan:any) => {
    setCurrentSelectedPlan(plan);

  }

  const currency = "USD";

  const onChangePlanHandler = () => {
    navigate(paths.dashboard.taxShield.enrollment, {state: {action: 'changePlan'}});
  }

  return (
    <>
     <div className="page-container">
      <Container sx={{ mb: 5 }}>
        <Breadcrumbs
          aria-label="breadcrumb"
          sx={{ mt: "10px", p: "14px 60px" }}
        >
          <Link color="inherit" onClick={() => navigate("/dashboard/tax-shield/enrollment")} sx={{cursor: 'pointer'}}>
            Home
          </Link>
          <Typography color="inherit">Account Settings</Typography>
          <Link color="inherit" onClick={() => navigate(paths.settings.myaccount.paymentMethods)} sx={{cursor: 'pointer'}}>
            Billing
          </Link>
          <Typography color="textPrimary">Change Plan</Typography>
        </Breadcrumbs>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              width: "80%",
            }}
          >
            <Box className="headerTitleBox">
              <Typography variant="h5" className="headerTitle">
              Optima Tax Shield Plan 
              </Typography>
            </Box>
            {loading? <Loading /> :
            <Box className="formContainerBox">
              <div className="d-inline-flex ms-4 mt-2">
                <div className="align-content-center me-2">
                  <CreditcardIcon />
                </div>
                <div>
                  <Typography variant="h6">
                    Change plan
                  </Typography>
                  <Typography variant="body2">
                    You can upgrade, downgrade, or cancel whenever you want
                  </Typography>
                </div>
              </div>
              <Grid container spacing={3} sx={{ margin: "1rem", width:'90%' }}>
              {plans?.map(planInfo => {
                return (
                  <Grid md={3} lg={3} xs={12} sm={12} key={planInfo.Id} sx={{marginTop: '1rem'}}>
                  <Card sx={[ {display: 'flex', flexDirection: 'column', height: '100%', marginRight: '1rem', 
                      cursor:'pointer'},
                      (subscriptionInfo && subscriptionInfo.ProtectionPlanName === planInfo.Name) && {cursor: 'default', pointerEvents: 'none'},
                      (currentSelectedPlan && currentSelectedPlan.Name === planInfo.Name) && {border: '2px solid #529AF9'} ]} 
                        onClick={() => onPlanSelectHandler(planInfo)}
                        >
                    <Box sx={{ p: 2 }}>
                      <Box sx={{ height: '30px', width: '40px', mb:2 }}>
                        <PlanIcon name={planInfo.Name} />
                      </Box>
                      <Box sx={{display: 'inline-flex', justifyContent: 'space-between'}}>
                      <Typography variant="body2" sx={{fontWeight: 600, textTransform: 'uppercase', mb:2}}>
                        {planInfo.Title}
                      </Typography>
                      {(subscriptionInfo && subscriptionInfo.ProtectionPlanName === planInfo.Name) && <Chip label={'Selected'} size="small" 
                            sx={{marginLeft: '0.5rem', marginRight: '0.5rem', bgcolor: '#F0FDFA',
                              color: '#134E48',}}/>}
                      </Box>
                      <Box sx={{ alignItems: 'flex-end', display: 'flex', gap: 1 }}>
                        <Typography variant="h5">
                          {new Intl.NumberFormat('en-US', {
                            style: 'currency',
                            currency,
                            maximumFractionDigits: planInfo.MonthlyPrice === 0 ? 0 : 2,
                          }).format(planInfo.MonthlyPrice)}
                        </Typography>
                        <Typography color="text.secondary" variant="subtitle2">
                          /mo
                        </Typography>
                      </Box>
                    </Box>
                  </Card>
                  </Grid>
                )
              })}
              </Grid>
              <Typography variant="body2" sx={{marginLeft: '1rem', fontSize: '0.75rem'}}>
                We cannot refund once you purchased a subscription, but you can always <a className="letsdolater" onClick={() => navigate(paths.settings.myaccount.paymentMethods)}>Cancel</a>
              </Typography>
              <Box sx={{ display: 'flex', justifyContent: 'end', marginRight: '1rem', marginBottom: '2rem'}}>
              <button
                className={"btn-continue fw-bold"}
                onClick={onChangePlanHandler}
              >
                Change Plan
              </button>
              </Box>
            </Box>
            }
          </Box>
        </Box>
      </Container>
      </div>
      <Footer/>
    </>
  );
}

export default ChangeProtectionPlan;


interface PlanIconProps {
  name: string;
}

function PlanIcon({ name }: PlanIconProps): React.JSX.Element | null {
  switch (name) {
    case 'Free':
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" fill="none">
        <path d="M22.6744 0.492981L31.9038 5.55771C32.117 5.67468 32.2944 5.84498 32.4178 6.05102C32.5413 6.25713 32.6064 6.49154 32.6064 6.73031C32.6064 6.96907 32.5413 7.20348 32.4178 7.4096C32.2944 7.61564 32.117 7.78594 31.9038 7.9029L22.6745 12.9679C22.0854 13.2911 21.4212 13.4609 20.7456 13.4609C20.0698 13.4609 19.4056 13.2911 18.8166 12.9679L9.5873 7.9029C9.37415 7.78594 9.1967 7.61564 9.0732 7.4096C8.94971 7.20348 8.8846 6.96907 8.8846 6.73031C8.8846 6.49154 8.94971 6.25713 9.0732 6.05102C9.1967 5.84498 9.37415 5.67468 9.5873 5.55771L18.8166 0.492981C19.4056 0.169739 20.0698 -5.72205e-06 20.7456 -5.72205e-06C21.4212 -5.72205e-06 22.0854 0.169739 22.6744 0.492981Z" fill="#529AF9"/>
        </svg>
      );
    case 'Standard':
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" fill="none">
          <path d="M22.6744 0.492981L31.9038 5.55771C32.117 5.67468 32.2944 5.84498 32.4178 6.05102C32.5413 6.25713 32.6064 6.49154 32.6064 6.73031C32.6064 6.96907 32.5413 7.20348 32.4178 7.4096C32.2944 7.61564 32.117 7.78594 31.9038 7.9029L22.6745 12.9679C22.0854 13.2911 21.4212 13.4609 20.7456 13.4609C20.0698 13.4609 19.4056 13.2911 18.8166 12.9679L9.5873 7.9029C9.37415 7.78594 9.1967 7.61564 9.0732 7.4096C8.94971 7.20348 8.8846 6.96907 8.8846 6.73031C8.8846 6.49154 8.94971 6.25713 9.0732 6.05102C9.1967 5.84498 9.37415 5.67468 9.5873 5.55771L18.8166 0.492981C19.4056 0.169739 20.0698 -5.72205e-06 20.7456 -5.72205e-06C21.4212 -5.72205e-06 22.0854 0.169739 22.6744 0.492981Z" fill="#529AF9"/>
          <path opacity="0.7" d="M22.6244 5.24762L35.8422 12.5011C36.0554 12.6181 36.2328 12.7884 36.3563 12.9944C36.4798 13.2005 36.5449 13.4349 36.5449 13.6737C36.5449 13.9125 36.4798 14.147 36.3563 14.353C36.2328 14.5591 36.0554 14.7293 35.8422 14.8464L22.6244 22.0998C22.0355 22.4229 21.3712 22.5928 20.6956 22.5928C20.0199 22.5928 19.3557 22.4229 18.7667 22.0998L5.54893 14.8464C5.33578 14.7293 5.15833 14.5591 5.03483 14.353C4.91133 14.147 4.84623 13.9125 4.84623 13.6737C4.84623 13.4349 4.91133 13.2005 5.03483 12.9944C5.15833 12.7884 5.33578 12.6181 5.54893 12.5011L18.7667 5.24762C19.3557 4.92445 20.0199 4.75471 20.6956 4.75471C21.3712 4.75471 22.0355 4.92445 22.6244 5.24762Z" fill="#529AF9"/>
        </svg>
      );
    case 'Premium':
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" fill="none">
          <path d="M22.6744 0.492981L31.9038 5.55771C32.117 5.67468 32.2944 5.84498 32.4178 6.05102C32.5413 6.25713 32.6064 6.49154 32.6064 6.73031C32.6064 6.96907 32.5413 7.20348 32.4178 7.4096C32.2944 7.61564 32.117 7.78594 31.9038 7.9029L22.6745 12.9679C22.0854 13.2911 21.4212 13.4609 20.7456 13.4609C20.0698 13.4609 19.4056 13.2911 18.8166 12.9679L9.5873 7.9029C9.37415 7.78594 9.1967 7.61564 9.0732 7.4096C8.94971 7.20348 8.8846 6.96907 8.8846 6.73031C8.8846 6.49154 8.94971 6.25713 9.0732 6.05102C9.1967 5.84498 9.37415 5.67468 9.5873 5.55771L18.8166 0.492981C19.4056 0.169739 20.0698 -5.72205e-06 20.7456 -5.72205e-06C21.4212 -5.72205e-06 22.0854 0.169739 22.6744 0.492981Z" fill="#529AF9"/>
          <path opacity="0.7" d="M22.6244 5.24762L35.8422 12.5011C36.0554 12.6181 36.2328 12.7884 36.3563 12.9944C36.4798 13.2005 36.5449 13.4349 36.5449 13.6737C36.5449 13.9125 36.4798 14.147 36.3563 14.353C36.2328 14.5591 36.0554 14.7293 35.8422 14.8464L22.6244 22.0998C22.0355 22.4229 21.3712 22.5928 20.6956 22.5928C20.0199 22.5928 19.3557 22.4229 18.7667 22.0998L5.54893 14.8464C5.33578 14.7293 5.15833 14.5591 5.03483 14.353C4.91133 14.147 4.84623 13.9125 4.84623 13.6737C4.84623 13.4349 4.91133 13.2005 5.03483 12.9944C5.15833 12.7884 5.33578 12.6181 5.54893 12.5011L18.7667 5.24762C19.3557 4.92445 20.0199 4.75471 20.6956 4.75471C21.3712 4.75471 22.0355 4.92445 22.6244 5.24762Z" fill="#529AF9"/>
          <path opacity="0.4" d="M22.9257 10.0016L41.2984 20.0841C41.5113 20.201 41.6884 20.3709 41.8117 20.5767C41.935 20.7824 42 21.0165 42 21.2549C42 21.4933 41.935 21.7273 41.8117 21.9331C41.6884 22.1388 41.5113 22.3088 41.2984 22.4256L22.9257 32.5078C22.3377 32.8305 21.6745 33 21 33C20.3254 33 19.6623 32.8305 19.0743 32.5078L0.701542 22.4256C0.488743 22.3088 0.311581 22.1388 0.188286 21.9331C0.0649948 21.7273 0 21.4933 0 21.2549C0 21.0165 0.0649948 20.7824 0.188286 20.5767C0.311581 20.3709 0.488743 20.201 0.701542 20.0841L19.0743 10.0016C19.6623 9.67899 20.3254 9.50945 21 9.50945C21.6745 9.50945 22.3377 9.67899 22.9257 10.0016Z" fill="#529AF9"/>
        </svg>
      );
    case 'Professional':
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" fill="none">
          <path d="M22.6744 0.492981L31.9038 5.55771C32.117 5.67468 32.2944 5.84498 32.4178 6.05102C32.5413 6.25713 32.6064 6.49154 32.6064 6.73031C32.6064 6.96907 32.5413 7.20348 32.4178 7.4096C32.2944 7.61564 32.117 7.78594 31.9038 7.9029L22.6745 12.9679C22.0854 13.2911 21.4212 13.4609 20.7456 13.4609C20.0698 13.4609 19.4056 13.2911 18.8166 12.9679L9.5873 7.9029C9.37415 7.78594 9.1967 7.61564 9.0732 7.4096C8.94971 7.20348 8.8846 6.96907 8.8846 6.73031C8.8846 6.49154 8.94971 6.25713 9.0732 6.05102C9.1967 5.84498 9.37415 5.67468 9.5873 5.55771L18.8166 0.492981C19.4056 0.169739 20.0698 -5.72205e-06 20.7456 -5.72205e-06C21.4212 -5.72205e-06 22.0854 0.169739 22.6744 0.492981Z" fill="#529AF9"/>
          <path opacity="0.7" d="M22.6244 5.24762L35.8422 12.5011C36.0554 12.6181 36.2328 12.7884 36.3563 12.9944C36.4798 13.2005 36.5449 13.4349 36.5449 13.6737C36.5449 13.9125 36.4798 14.147 36.3563 14.353C36.2328 14.5591 36.0554 14.7293 35.8422 14.8464L22.6244 22.0998C22.0355 22.4229 21.3712 22.5928 20.6956 22.5928C20.0199 22.5928 19.3557 22.4229 18.7667 22.0998L5.54893 14.8464C5.33578 14.7293 5.15833 14.5591 5.03483 14.353C4.91133 14.147 4.84623 13.9125 4.84623 13.6737C4.84623 13.4349 4.91133 13.2005 5.03483 12.9944C5.15833 12.7884 5.33578 12.6181 5.54893 12.5011L18.7667 5.24762C19.3557 4.92445 20.0199 4.75471 20.6956 4.75471C21.3712 4.75471 22.0355 4.92445 22.6244 5.24762Z" fill="#529AF9"/>
          <path opacity="0.4" d="M22.9257 10.0016L41.2984 20.0841C41.5113 20.201 41.6884 20.3709 41.8117 20.5767C41.935 20.7824 42 21.0165 42 21.2549C42 21.4933 41.935 21.7273 41.8117 21.9331C41.6884 22.1388 41.5113 22.3088 41.2984 22.4256L22.9257 32.5078C22.3377 32.8305 21.6745 33 21 33C20.3254 33 19.6623 32.8305 19.0743 32.5078L0.701542 22.4256C0.488743 22.3088 0.311581 22.1388 0.188286 21.9331C0.0649948 21.7273 0 21.4933 0 21.2549C0 21.0165 0.0649948 20.7824 0.188286 20.5767C0.311581 20.3709 0.488743 20.201 0.701542 20.0841L19.0743 10.0016C19.6623 9.67899 20.3254 9.50945 21 9.50945C21.6745 9.50945 22.3377 9.67899 22.9257 10.0016Z" fill="#529AF9"/>
        </svg>
      );
    default:
      return null;
  }
}

